import {
  Grid, Header,
  SidebarLayout,
  ThemeType,
  toggleTheme
} from "@scuf/common";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import FooterToast from "../../components/footer/FooterToast";
import { useAuth } from "../../hooks/useAuth";
import apc from "../../img/icon/APC.png"
import ajustes from "../../img/icon/Ajustes Modelo.png"
import domo from "../../img/icon/Domo.png"
import estrategico from "../../img/icon/Estrategico.png"
import etpPJG from "../../img/icon/ETP_PJG.png"
import modeloDomo from "../../img/icon/M. Domo.png"
import pas from "../../img/icon/PAS.png"
import pfd from "../../img/icon/PFD-Tostador.png"
import tgd from "../../img/icon/TdG.png"
import tostador from "../../img/icon/tostador.png"

import "./Layout.css";

/**
 * Función principal que guarda nuestro layout de navegación
 * @param {*} props
 * @returns
 */
export default function Layout(props) {
  const { logout } = useAuth();

  // creamos constante para navegar
  const history = useHistory();
  // state's para controlar el colapsado de la side bar
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  // state's para manipular el nombre activo dentro del side bar
  const [activeName, setActiveName] = useState("ESTRATEGICO");
  // state's para manipular el titulo del header
  const [titleHeader, setTitleHeader] = useState("ESTRATÉGICO");
  /**
   * useEffect para establecer la variable de theme en dark por defecto
   */
  useEffect(() => {
    toggleTheme(ThemeType.Dark);
    setActiveName("ESTRATÉGICO");
  }, []);

  /**
   * Función que nos permite ocultar el menu lateral
   */
  function onCollapsedClick() {
    setSidebarCollapsed(!sidebarCollapsed);
  }

  /**
   * Función que nos permite manicular el activo del los items del side bar
   * @param {*} event
   * @param {*} props
   */
  function handleItemClick(event, props) {
    // Negamos la accion nativa del evento
    event.preventDefault();
    const { name, to, titleHeader } = props;
    // setiamos el valor del nombre activo
    setActiveName(name);
    // setiamos el valor del header
    setTitleHeader(titleHeader);
    // Redireccionamos a la pagina donde debe ir
    history.push(`/${to}`);
  }

  return (
    <>
      <Header
        isForge={true}
        title={titleHeader}
        onMenuToggle={() => onCollapsedClick()}
        menu={true}
      >
        <Header.UserProfile>
          <Header.UserProfile.Item key={"my-profile"}>
            Mi perfil
          </Header.UserProfile.Item>
          <Header.UserProfile.Item
            key={"desconected"}
            onClick={() => {
              logout();
              history.push("/login");
            }}
          >
            Desconectar
          </Header.UserProfile.Item>
        </Header.UserProfile>
      </Header>

      <SidebarLayout collapsed={sidebarCollapsed}>
        <SidebarLayout.Sidebar>
          <SidebarLayout.Sidebar.Item
            content="ESTRATÉGICO"
            name="ESTRATÉGICO"
            icon={<img className="icon-layout-mining" src={estrategico} alt="icon-apc"></img>}
            activeName={activeName}
            to="estrategico"
            onClick={handleItemClick}
          />
          <SidebarLayout.Sidebar.Item
            content="APC"
            name="APC"
            icon={<img className="icon-layout-mining" src={apc} alt="icon-apc"></img>}
            to="apc"
            activeName={activeName}
            onClick={handleItemClick}
          />
          <SidebarLayout.Sidebar.Item
            content="DOMO"
            name="DOMO"
            icon={<img className="icon-layout-mining" src={domo} alt="icon-apc"></img>}
            to="domo"
            activeName={activeName}
            onClick={handleItemClick}
          />
          <SidebarLayout.Sidebar.Item
            content="PFD - TOSTACIÓN"
            name="PFD - TOSTACIÓN"
            icon={<img className="icon-layout-mining" src={pfd} alt="icon-apc"></img>}
            to="PFD-tostacion"
            activeName={activeName}
            onClick={handleItemClick}
          />
          <SidebarLayout.Sidebar.Item
            content="TOSTADOR"
            name="TOSTADOR"
            icon={<img className="icon-layout-mining" src={tostador} alt="icon-apc"></img>}
            to="tostador"
            activeName={activeName}
            onClick={handleItemClick}
          />
          <SidebarLayout.Sidebar.Item
            content="TREN DE GASES"
            name="TREN DE GASES"
            icon={<img className="icon-layout-mining" src={tgd} alt="icon-apc"></img>}
            to="tgases"
            activeName={activeName}
            onClick={handleItemClick}
          />

          <SidebarLayout.Sidebar.Item
            content="PLG-ETP"
            name="PLG-ETP"
            icon={<img className="icon-layout-mining" src={etpPJG} alt="icon-apc"></img>}
            to="plg-etp"
            activeName={activeName}
            onClick={handleItemClick}
          />

          <SidebarLayout.Sidebar.Item
            content="PLANTA DE ÁCIDO"
            name="PLANTA DE ÁCIDO"
            icon={<img className="icon-layout-mining" src={pas} alt="icon-apc"></img>}
            to="pacido"
            activeName={activeName}
            onClick={handleItemClick}
          />

          <SidebarLayout.Sidebar.Item
            content="MODELO DOMO"
            name="MODELO DOMO"
            icon={<img className="icon-layout-mining" src={modeloDomo} alt="icon-apc"></img>}
            to="animated-domo"
            activeName={activeName}
            onClick={handleItemClick}
          />

          <SidebarLayout.Sidebar.Item
            content="AJUSTES MODELO"
            name="AJUSTES MODELO"
            icon={<img className="icon-layout-mining" src={ajustes} alt="icon-apc"></img>}
            to="preferencias"
            activeName={activeName}
            onClick={handleItemClick}
          />
        </SidebarLayout.Sidebar>

        <SidebarLayout.Content>
          <Grid>
            <Grid.Row>
              <Grid.Column width={12}>{props.component}</Grid.Column>
            </Grid.Row>
          </Grid>
        </SidebarLayout.Content>
      </SidebarLayout>

      <FooterToast className={"footer-content"} />
    </>
  );
}
